import './crossSell.css';

const aroundYouTabModule = () => import(/* webpackChunkName: 'components/aroundYouTab' */'../geolocAroundYouTab/geolocAroundYouTab');

export const crossSell = {
  selectors: {
    main: '.js-cs',
    tabsSelector: '.js-tabs'
  },

  initOrRefresh: options => {
    options = typeof options === 'object' ? options : {};

    const aroundDomainTabSelector = `${crossSell.selectors.main} ${crossSell.selectors.tabsSelector} [data-tabcode="AROUND_DOMAIN"]`;
    const event_domain = 'click.AROUND_DOMAIN';

    $(document).off(event_domain, aroundDomainTabSelector).on(event_domain, aroundDomainTabSelector, () => {
      crossSell.initOrRefresh({forceTabToShow: 'AROUND_DOMAIN'});
    });

    $.extend(options, {
      originId: 'crosssell',
      mainSelector: crossSell.selectors.main,
      refreshGeolocEventName: 'crosssell:refreshCrossSell',
      tabToShowInCaseOfFailure: 'AROUND_DOMAIN',
      showTab: true,
      additionnalAjaxParams: {
        nb: 9,
        c: PRODUCT_SCRIPTS.COLLECTION_ID,
        'exclude[]': PRODUCT_SCRIPTS.PRODUCT_CODE
      },
      additionnalAjaxParamsInCaseOfGeolocFailure: {
        country: PRODUCT_SCRIPTS.COUNTRY_CODE,
        'geo[lat]': PRODUCT_SCRIPTS.lat,
        'geo[lon]': PRODUCT_SCRIPTS.long
      }
    });

    aroundYouTabModule().then(({aroundYouTab}) => {aroundYouTab.initOrRefresh(options);});
  }
};